"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useCloseWhenClickedOutside;

var _react = require("react");

var ESC_KEY = 27;

function useCloseWhenClickedOutside(closeFn) {
  var node = (0, _react.useRef)();

  var handleClick = function handleClick(e) {
    var clickedInside = node.current.contains(e.target);

    if (clickedInside) {
      return;
    }

    closeFn(e);
  };

  var handleKeyDown = function handleKeyDown(e) {
    var escapeKeyPressed = e.which === ESC_KEY;

    if (!escapeKeyPressed) {
      return;
    }

    closeFn(e);
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return node;
}